<div
  class="user-settings-component-container notification-settings-container"
  (scroll)="pageScrolled($event)"
>
  @if (popupSettings.length > 0){
  <ng-container *ngTemplateOutlet="popupHeader"></ng-container>

  @for (setting of popupSettings; track setting.eventIdentifier + setting.type) {
  <bfx-notification-setting
    class="notification-setting-popup"
    [ngModel]="setting"
    (ngModelChange)="settingChanged( setting, $event)"
    (validChanged)="validChanged( setting, $event)"
    [audioDisabled]="audioDisabled"
  >
  </bfx-notification-setting>
  } } @if (applicationSettings.length > 0){
  <ng-container *ngTemplateOutlet="applicationHeader"></ng-container>

  @for (setting of applicationSettings; track setting.eventIdentifier + setting.type) {
  <bfx-notification-setting
    class="notification-setting-application"
    [ngModel]="setting"
    (ngModelChange)="appSettingChanged( setting, $event)"
    (validChanged)="validChanged( setting, $event)"
    [audioDisabled]="audioDisabled"
  >
  </bfx-notification-setting>
  } }
</div>

<!-- HTML Template for Popup Notifications Header-->
<ng-template #popupHeader>
  <div class="ds-cont-typography-productive-title-sm">{{popupRowTitle}}</div>
  <div class="notification_popup_container_popup_header">
    <div class="title-row">
      <div class="col-name">Event</div>
      <div class="col-enabled">Enabled</div>
      <div class="disable_sound_wrapper col-audio">
        Audio
        <bfx-icon-button
          size="sm"
          [iconClass]="audioDisabled?'icon-bfx_volume_off':'icon-bfx_volume_on'"
          (action)="toggleAudio()"
          [title]="audioDisabled?'Enable all audio':'Disable all audio'"
        >
        </bfx-icon-button>
      </div>
      <div class="col-filter">Filter</div>
    </div>
  </div>
</ng-template>

<!-- HTML Template for Application Notifications Header-->
<ng-template #applicationHeader>
  <div class="ds-cont-typography-productive-title-sm">{{appRowTitle}}</div>
  <div class="notification_popup_container_popup_header">
    <div class="title-row title-row_disable_sound">
      <div class="app-col-name">Event</div>
      <div class="col-enabled">In App</div>
      <div
        class="col-return-at-login"
        title="Return notifications at login since the user last logged out"
      >
        Login
      </div>
      <div class="disable_sound_wrapper col-audio">
        Audio
        <bfx-icon-button
          size="sm"
          [iconClass]="audioDisabled?'icon-bfx_volume_off':'icon-bfx_volume_on'"
          (action)="toggleAudio()"
          [title]="audioDisabled?'Enable all audio':'Disable all audio'"
        >
        </bfx-icon-button>
      </div>
      <div class="col-filter">Filter</div>
    </div>
  </div>
</ng-template>
